module.exports = __webpack_public_path__ + "img/67_02.629b1c43.png";